
const dev = process.env.VUE_APP_USE_PROXY.toLocaleLowerCase() === "true" && process.env.NODE_ENV === "development";
let baseUrl;
if (dev) {
  baseUrl = process.env.VUE_APP_BASE_API + "/health/console";
} else {
  baseUrl = "https://api.xaou.sn.cn" + process.env.VUE_APP_BASE_API + "/health/console";
  // baseUrl = getConfigInfo().baseApiUrl + process.env.VUE_APP_BASE_API + "/open";
}
export { baseUrl };
